import {slideDown, slideUp} from "./utilities/slide";

function openAccordionSection(section) {
    let content = section.querySelector(".schema-faq-answer");
    section.classList.add("is-active");
    if (content) {
        slideDown(content)
    }
}

function closeAccordionSection(section) {
    section.classList.remove("is-active");
    let content = section.querySelector(".schema-faq-answer");
    if (content) {
        slideUp(content);
    }
}
export function accordion(){
    for(let section of document.querySelectorAll('.schema-faq-section')){
        let title = section.querySelector(".schema-faq-question");

        if(title){
            title.addEventListener("click",function (e){
                if (section.classList.contains("is-active")) {
                    closeAccordionSection(section);
                } else {
                    openAccordionSection(section);
                }
            });
        }
    }
}